import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  projectId: null,
  status: null,
  action: null,
  message: null,
  warnings: [],
};

const socketSlice = createSlice({
  name: 'socket',
  initialState,
  reducers: {
    clearSocketMessages: (state) => {
      state.projectId = null;
      state.status = null;
      state.action = null;
      state.message = null;
      state.warnings = [];
    },
    userMsg: (state, action) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { clearSocketMessages, userMsg } = socketSlice.actions;
export default socketSlice.reducer;
